"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _StencilContext = require("./StencilContext");

var _propTypes = require("./propTypes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var dummy = function dummy() {
  return null;
};

var DescribedStencilProviderWithDocs = (0, _stencilReactDesc.describe)(dummy).description('Parent provider for Stencil Components.');
DescribedStencilProviderWithDocs.propTypes = _objectSpread({}, _propTypes.providerPropTypes);
DescribedStencilProviderWithDocs.defaultProps = _objectSpread({}, _StencilContext.StencilProvider.defaultProps);
DescribedStencilProviderWithDocs.displayName = 'DescribedStencilProvider';
var _default = DescribedStencilProviderWithDocs;
exports.default = _default;